// import React, { useCallback, useEffect, useState, useRef } from "react";
// import classnames from "classnames";
// import PropTypes from "prop-types";
// import "./Multirange.css";

// const MultiRangeSlider = ({ min, max, minVal, maxVal, setMinVal, setMaxVal, onChange }) => {
//   const minValRef = useRef(null);
//   const maxValRef = useRef(null);
//   const [isPlus,setIsplus] = useState(false)
//     const range = useRef(null);
//   // Convert to percentage
//   const getPercent = useCallback(
//     (value) => Math.round(((value - min) / (max - min)) * 100),
//     [min, max]
//   );

//   // Set width of the range to decrease from the left side
//   useEffect(() => {
    
//     if (maxValRef.current) {
//       const minPercent = getPercent(minVal);
//       const maxPercent = getPercent(+maxValRef.current.value); // Preceding with '+' converts the value from type string to type number

//       if (range.current) {
//         range.current.style.left = `${minPercent}%`;
//         range.current.style.width = `${maxPercent - minPercent}%`;
//       }
//     }
//   }, [minVal, getPercent]);

//   useEffect(()=>{
//     if(parseInt(maxVal) === parseInt(max)){
//       setIsplus(true)
//     }else{
//       setIsplus(false)
//     }
//   },[max,maxVal])
//   // Set width of the range to decrease from the right side
//   useEffect(() => {
//     if (minValRef.current) {
//       const minPercent = getPercent(+minValRef.current.value);
//       const maxPercent = getPercent(maxVal);

//       if (range.current) {
//         range.current.style.width = `${maxPercent - minPercent}%`;
//       }
//     }
//   }, [maxVal, getPercent]);

//   // Get min and max values when their state changes
//   useEffect(() => {
//     onChange({ min: minVal, max: maxVal });
//   }, [minVal, maxVal, onChange]);

//   return (
//     <div className="containerslider">
//       <input
//         type="range"
//         min={min}
//         max={max}
//         value={minVal}
//         ref={minValRef}
//         onChange={(event) => {
//           const value = Math.min(+event.target.value, maxVal - 1);
//           setMinVal(value);


//           event.target.value = value.toString();
//         }}
//         className={classnames("thumb thumb--zindex-3", {
//           "thumb--zindex-5": minVal > max - 100,
//         })}
//       />
//       <input
//         type="range"
//         min={min}
//         max={max}
//         value={maxVal}
//         ref={maxValRef}
//         onChange={(event) => {
//           const value = Math.max(+event.target.value, minVal + 1);
//           setMaxVal(value);

//           event.target.value = value.toString();
//         }}
//         className="thumb thumb--zindex-4"
//       />

//       <div className="slider">
//         <div className="slider__track" />
//         <div ref={range} className="slider__range" />
//         <div className="slider__left-value">{minVal}</div>
//         <div className="slider__right-value">{maxVal} {isPlus && <span style={{fontSize:"15px"}}>{"+"}</span>}</div>
//       </div>
//     </div>
//   );
// };

// MultiRangeSlider.propTypes = {
//   min: PropTypes.number.isRequired,
//   max: PropTypes.number.isRequired,
//   onChange: PropTypes.func.isRequired,
// };

// export default MultiRangeSlider;




import React, { useCallback, useEffect, useState, useRef } from "react";
import "./Multirange.css";

const MultiRangeSlider = ({ min, max, minVal, maxVal, setMinVal, setMaxVal, onChange }) => {
  const sliderRef = useRef(null);
  const range = useRef(null);
  const [isPlus, setIsPlus] = useState(false);
  const [activeThumb, setActiveThumb] = useState(null);
  const [startValue, setStartValue] = useState(0);
  const [startPosition, setStartPosition] = useState(0);

  // Convert to percentage
  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  );

  // Convert position to value
  const getValueFromPosition = useCallback(
    (position) => {
      const slider = sliderRef.current;
      if (!slider) return 0;

      const rect = slider.getBoundingClientRect();
      const percent = (position - rect.left) / rect.width;
      return Math.round(percent * (max - min) + min);
    },
    [min, max]
  );

  // Handle start of drag
  const handleStart = useCallback((e, thumb) => {
    e.preventDefault();
    e.stopPropagation();
    
    const position = e.touches ? e.touches[0].clientX : e.clientX;
    setActiveThumb(thumb);
    setStartPosition(position);
    setStartValue(thumb === 'min' ? minVal : maxVal);
    
    // Prevent text selection during drag
    document.body.style.userSelect = 'none';
  }, [minVal, maxVal]);

  // Handle drag movement
  const handleMove = useCallback((e) => {
    if (!activeThumb || !sliderRef.current) return;

    const position = e.touches ? e.touches[0].clientX : e.clientX;
    const delta = position - startPosition;
    const sliderRect = sliderRef.current.getBoundingClientRect();
    const valueRange = max - min;
    const valueDelta = (delta / sliderRect.width) * valueRange;
    
    let newValue = Math.round(startValue + valueDelta);
    newValue = Math.max(min, Math.min(max, newValue));

    if (activeThumb === 'min') {
      newValue = Math.min(newValue, maxVal - 1);
      setMinVal(newValue);
    } else {
      newValue = Math.max(newValue, minVal + 1);
      setMaxVal(newValue);
    }
  }, [activeThumb, startPosition, startValue, min, max, minVal, maxVal, setMinVal, setMaxVal]);

  // Handle end of drag
  const handleEnd = useCallback(() => {
    setActiveThumb(null);
    document.body.style.userSelect = '';
  }, []);

  // Update range position
  useEffect(() => {
    if (range.current) {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(maxVal);
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, maxVal, getPercent]);

  // Update plus sign
  useEffect(() => {
    setIsPlus(parseInt(maxVal) === parseInt(max));
  }, [max, maxVal]);

  // Update onChange
  useEffect(() => {
    onChange({ min: minVal, max: maxVal });
  }, [minVal, maxVal, onChange]);

  // Add and remove event listeners
  useEffect(() => {
    const handleTouchMove = (e) => {
      e.preventDefault();
      handleMove(e);
    };

    if (activeThumb) {
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('touchend', handleEnd);
      document.addEventListener('mouseup', handleEnd);
    }

    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('mousemove', handleMove);
      document.removeEventListener('touchend', handleEnd);
      document.removeEventListener('mouseup', handleEnd);
    };
  }, [activeThumb, handleMove, handleEnd]);

  return (
    <div className="containerslider" ref={sliderRef}>
      <div className="slider">
        <div className="slider__track" />
        <div ref={range} className="slider__range" />
        
        <div 
          className="thumb thumb--left"
          style={{ 
            left: `${getPercent(minVal)}%`,
            zIndex: activeThumb === 'min' ? 5 : 3
          }}
          onTouchStart={(e) => handleStart(e, 'min')}
          onMouseDown={(e) => handleStart(e, 'min')}
        />
        
        <div 
          className="thumb thumb--right"
          style={{ 
            left: `${getPercent(maxVal)}%`,
            zIndex: activeThumb === 'max' ? 5 : 4
          }}
          onTouchStart={(e) => handleStart(e, 'max')}
          onMouseDown={(e) => handleStart(e, 'max')}
        />

        <div className="slider__left-value">{minVal}</div>
        <div className="slider__right-value">
          {maxVal}{isPlus && <span style={{fontSize:"15px"}}>+</span>}
        </div>
      </div>
    </div>
  );
};

export default MultiRangeSlider;